import { render } from "./practice-dashboard.html?vue&type=template&id=302262b4&scoped=true&ts=true&external"
import script from "./practice-dashboard.ts?vue&type=script&lang=ts&external"
export * from "./practice-dashboard.ts?vue&type=script&lang=ts&external"

import "./practice-dashboard.scss?vue&type=style&index=0&id=302262b4&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-302262b4"]])

export default __exports__